export const DEFAULT_FOOBAR = "DEFAULT_FOOBAR";

export const CLUB_FOOBAR = "CLUB_FOOBAR";
export const EMPTY_FOOBAR = "EMPTY_FOOBAR";
